/**
 * Application Configuration
 * Selects the appropriate API URL based on REACT_APP_ENV
 */

const ENV = process.env.REACT_APP_ENV || 'local';

const API_URLS = {
  local: process.env.REACT_APP_API_LOCAL_URL || 'http://localhost:5001/api',
  staging: process.env.REACT_APP_API_STAGING_URL || 'https://staging.bi.api.neoshift.ai/api',
  production: process.env.REACT_APP_API_PRODUCTION_URL || 'https://bi.api.neoshift.ai/api'
};

const config = {
  env: ENV,
  apiUrl: API_URLS[ENV] || API_URLS.local,
  isProduction: ENV === 'production',
  isStaging: ENV === 'staging',
  isLocalhost: ENV === 'local',
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''
};

// Log configuration in non-production environments for debugging
if (!config.isProduction) {
  console.log(`[Config] Environment: ${config.env}, API URL: ${config.apiUrl}`);
}

export default config;

